module.exports = {
  data() {
    return {
      showMore: false,
      titleCard: ''
    }
  },
  created() {
    this.initTitleCard()
  },
  methods: {
    initTitleCard() {
      const { meta } = this.$route
      this.sideOpen = meta.title.split(',')
      const title = this.sideOpen.slice(-1)[0]
      this.titleCard = title
    }
  }
}